import { UserCompany } from '@company/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithCompany } from '../company-state';
import { getCompanyState } from './feature.selector';

export const getUserCompaniesState: MemoizedSelector<
  StateWithCompany,
  StateUtils.LoaderState<UserCompany[]>
> = createSelector(getCompanyState, (state) => state?.userCompanies || {});

export const getUserCompaniesLoading: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getUserCompaniesState,
  (state) => state.loading,
);

export const getUserCompaniesError: MemoizedSelector<StateWithCompany, boolean> = createSelector(
  getUserCompaniesState,
  (state) => state.error,
);

export const getUserCompaniesValue: MemoizedSelector<StateWithCompany, UserCompany[]> = createSelector(
  getUserCompaniesState,
  (state) => state.value,
);
